import React from "react";
import HeroDotSphere from "./HeroDotSphere";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col bg-lab-ink text-lab-paper overflow-hidden">
      {/* Top rule + titleblock */}
      <div className="border-b border-lab-rule">
        <div className="max-w-[1400px] mx-auto w-full px-6 md:px-10 py-4 flex items-center justify-between font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
          <span>Azerty Labs</span>
          <span className="hidden sm:inline">Eurorack · Synthesis · Embedded AI</span>
          <span>Brest, FR · 2020–2022</span>
        </div>
      </div>

      {/* Main */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-[1400px] mx-auto w-full px-6 md:px-10 py-20 md:py-32">
          <div className="grid grid-cols-12 gap-6">
            {/* Index number */}
            <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
              <div>Index</div>
              <div className="text-lab-paper mt-1">00 / Home</div>
            </div>

            {/* Wordmark */}
            <div className="col-span-12 md:col-span-10">
              <div className="relative">
                <h1 className="font-display font-semibold leading-[0.9] tracking-tight text-[18vw] md:text-[11vw] lg:text-[10rem] text-lab-paper">
                  Azerty
                  <br />
                  Labs<span className="text-lab-accent">.</span>
                </h1>
                {/* Dot sphere • aligned to wordmark, reactive on hover */}
                <div
                  className="hidden lg:block absolute top-0 right-0 h-full aspect-square z-20"
                  aria-hidden="true"
                >
                  <HeroDotSphere />
                </div>
              </div>

              <div className="mt-10 grid grid-cols-12 gap-6 border-t border-lab-rule pt-6">
                <div className="col-span-12 md:col-span-6">
                  <p className="text-lg md:text-xl text-lab-paper leading-snug max-w-xl">
                    A small lab in Brest, France, exploring embedded AI
                    inside the tight constraints of Eurorack hardware. Built
                    between 2020 and 2022 • before generative AI reached
                    the mainstream.
                  </p>
                </div>
                <div className="col-span-6 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
                  <div className="text-lab-paper-dim">Focus</div>
                  <div className="text-lab-paper mt-1">Embedded AI</div>
                </div>
                <div className="col-span-6 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
                  <div>Modules</div>
                  <div className="text-lab-paper mt-1">03 Designed</div>
                </div>
                <div className="col-span-6 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
                  <div>Status</div>
                  <div className="text-lab-accent mt-1">Archived</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
